<script lang="ts">

    import { Table } from "sveltestrap";
    import type { Question } from "../../Model/Question";
    import Watch from "../Watch.svelte";
    import Editable from "./Editable.svelte";

    export let question: Question;

</script>

<Watch store={question.options.questionGrid.rows} let:value={rows}>
    {#each rows as row}
        <div class="grid-row">
            <h6 class="fw-bold">
                <Editable store={row.text} />
            </h6>
            <Table>
                <tbody>
                    <Watch store={question.options.questionGrid.columns} let:value={columns}>
                        {#each columns as column}
                            <tr>
                                <td>
                                    <Editable store={column.name} />
                                </td>
                                <td>
                                    <Watch store={column.type} let:value={type}>
                                        {#if ['text', 'date', 'amount'].includes(type)}
                                            <input type="text" class="form-control form-control-sm" disabled>
                                        {:else if type == 'check'}
                                            <input type="checkbox" class="form-check-input" disabled>
                                        {/if}
                                    </Watch>
                                </td>
                            </tr>
                        {/each}
                    </Watch>
                </tbody>
            </Table>
        </div>
    {/each}
</Watch>
